import styled from "styled-components";
import { Section, Container } from "../layout/primitives";

export const ServicesSectionWrapper = styled(Section)`
  padding: 42px 0;
`;

export const ServicesInner = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const ServicesTitle = styled.h2`
  font-size: 52px;
  line-height: 58px;
  margin: 0;
  text-align: center;

  @media screen and (max-width: 640px) {
    font-size: 32px;
    line-height: 38px;
  }
`;

export const ServicesGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ServiceCard = styled.div`
  background: #122334;
  border-radius: 18px;
  padding: 28px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-height: 220px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`;

export const ServiceIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background: rgba(255, 203, 102, 0.12);
  color: #ffcb66;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 203, 102, 0.25);

  svg {
    width: 26px;
    height: 26px;
  }
`;

export const ServiceTitle = styled.h3`
  margin: 6px 0 0;
  font-size: 20px;
  line-height: 26px;
  color: #f7f8fa;
`;

export const ServiceText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: rgba(247, 248, 250, 0.78);
`;
